import { render, staticRenderFns } from "./OsdSelector.vue?vue&type=template&id=36a88328&scoped=true&lang=pug&"
import script from "./OsdSelector.vue?vue&type=script&lang=ts&"
export * from "./OsdSelector.vue?vue&type=script&lang=ts&"
import style0 from "./OsdSelector.vue?vue&type=style&index=0&id=36a88328&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a88328",
  null
  
)

component.options.__file = "OsdSelector.vue"
export default component.exports